import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { TableHeader } from '../../models/table';

export type SortDirection = 'asc' | 'desc' | '';
const rotate: { [key: string]: SortDirection } = { asc: 'desc', desc: '', '': 'asc' };

@Component({
    selector: 'app-table',
    templateUrl: './table.component.html',
    standalone: false
})
export class TableComponent implements OnChanges {
  // Gets an array with all the table headers
  @Input() headers: TableHeader[];
  // Sets a label description for the table
  @Input() tableLabel = "Table list";
  // Enable or disable table filters
  @Input() enableFilters = false;
  // Emits the corresponding event for the onSearch function
  @Output() readonly searchEvent: EventEmitter<TableHeader> = new EventEmitter();
  // Emits the corresponding event for the onSort function
  @Output() readonly sortEvent: EventEmitter<TableHeader> = new EventEmitter();
  // Contains the icon for every sorting status
  orderIcon = "order-arrow";

  /**
   * Emits an event after the user types in the current input header
   * @param {TableHeader} header
   * @returns None
   */
  onSearch(header: TableHeader, event: Event): void {
    const input = event.target as HTMLInputElement;
    header.value = input.value;
    this.searchEvent.emit(header);
  }

  /**
   * Emits an event when the status and sort icon of the current header change
   * @param {TableHeader} header
   * @returns None
   */
  onSort(header: TableHeader) {
    header.sort = rotate[header.sort];
    this.changeSortingIcon(header);
    this.sortEvent.emit(header);
  }

  /**
   * Sets the corresponding icon depending on the sorting type
   * @param {TableHeader} header
   * @returns None
   */
  changeSortingIcon(header: TableHeader) {
    switch (header.sort) {
      case 'asc':
        this.orderIcon = "order-arrow-up";
        break;
      case 'desc':
        this.orderIcon = "order-arrow-down";
        break;
      default:
        this.orderIcon = "order-arrow";
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    const filters = changes['enableFilters'];
    if (!filters?.currentValue) {
      this.headers = this.headers.map(header => {
        return { ...header, value: undefined }
      })
    }
  }
}